import { SxProps, Theme } from "@mui/material/styles";

const styles: SxProps<Theme> = [
  {
    padding: 3,
    paddingBottom: "12px",
    marginBottom: 3,
    background: "rgb(214, 212, 221)",
    "& > div": {
      marginBottom: 1,
    },
    "& h4": {
      marginTop: 0,
    },
  },
];

export default styles;
